<template>
    <div>
        <div ref="editor" contenteditable="true" @input="update" oncontextmenu="return false;"  @dblclick.left="showEditor = !showEditor"  @mousedown="showMenu = false">

        </div>

        <v-overlay :value="linkAdder" @click="linkAdder = false">
            <v-card light>
                <v-card-title>Ссылка</v-card-title>
                <v-card-text>
                    <v-text-field label="Ссылка" v-model="url" ref="inputl"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <div class="flex-md-grow-1"></div>
                    <v-btn
                            color="#8a2be2"
                            text
                            @click="linkAdder = false"
                    >
                        Отмена
                    </v-btn>
                    <v-btn
                            color="#8a2be2"
                            text
                            @click="doLink"
                    >
                        Сохранить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-overlay>
        <v-overlay absolute  :value="showEditor" @click="showEditor = false">


            <div style="min-width: 700px">
              <textedtor  @update_content="update_content_m($event)" :value="value"></textedtor>
                <v-btn
                        color="#FFAB91"

                        depressed
                        @click="showEditor = false"
                        style="margin-top: -67px"
                >
                    <b>OK</b>
                </v-btn>
            </div>

        </v-overlay >
        <v-menu
                v-model="showMenu"
                :close-on-content-click = "false"
                style="max-width: 600px"
                :position-x="x"
                :position-y="y"
        >
            <v-btn-toggle
                    v-model="toggle_multiple"
                    dense
                    multiple
            >
                <v-btn @click="opentexteditor">
                    <v-icon>mdi-note-text-outline</v-icon>
                </v-btn>

<!--                <v-btn @click="openLinker">-->
<!--                    <v-icon>mdi-link</v-icon>-->
<!--                </v-btn>-->
            </v-btn-toggle>
        </v-menu>

    </div>
</template>

<script>
    import textedtor from "./textedtor";
    export default {
        components: {textedtor},
        props: ['value'],
        name: "HtmlEditor",
        data(){
            return{
                content: this.value,
                showMenu: false,
                showEditor:false,
                toggle_multiple: [],
                x: 0,
                y: 0,
                linkAdder: false,
                url: "",
                rangeToLink: null
            }
        },
        methods:{
            update_content_m($event){

                this.content = $event;
                this.$refs.editor.innerHTML = this.content
                this.update();

               // this.$emit('update_from_editor',$event);
            },
            opentexteditor(){

                this.showMenu = false;
                this.showEditor  = true;
            },
            openContextMenu(e){
                //this.showMenu = false
                var isBold = document.queryCommandState("bold")
                var isItalic = document.queryCommandState("italic")

                this.toggle_multiple = []
                if (isBold){
                    this.toggle_multiple.push(0)
                }
                if (isItalic){
                    this.toggle_multiple.push(1)
                }

                if(window.getSelection && window.getSelection().toString().length > 0 && !this.showMenu){
                    this.x = e.clientX;
                    this.y = e.clientY;
                    this.showMenu = true;
                }

            },
            update(){
                this.$emit('input', this.$refs.editor.innerHTML)
            },
            doBold(){
                document.execCommand('bold');
            },
            doItalic(){
                document.execCommand('italic');
            },
            openLinker(){
                var sel = window.getSelection();
                var range = sel.getRangeAt(0);

                var text = sel.toString()
                var first = document.createElement("SPAN")


                first.id = "keks1"
                first.innerHTML = text


                range.deleteContents()

                range.insertNode(first)

                this.linkAdder = true
                this.showMenu = false

                return false
                this.url = prompt("Введите адрес ссылки", "https://");
                if(this.url){
                    this.doLink();
                }
                this.showMenu = false
            },
            doLink(){
                var marker = document.getElementById("keks1")
                var res = document.createElement('A')
                res.href = this.url
                res.innerHTML = marker.innerHTML
                marker.parentNode.insertBefore(res, marker)
                marker.remove()
                this.linkAdder = false

            }
        },
        mounted(){
            this.$refs.editor.innerHTML = this.content
        }
    }
</script>

<style>
    a{
        text-decoration: none;
    }
</style>

<style scoped>

</style>